import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

import { ContactEven, ContactFiona, DepositsOfferProductSubType } from 'embed/constants'
import { DepositsOffer } from 'embed/constants/models'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { CommonState } from 'embed/reducers'
import { brandSelector } from 'embed/selectors/config'
import { depositsSavingsOffersSelector } from 'embed/selectors/rates'
import { formattedPhoneNumber } from 'embed/utils'
import { Brand } from 'even-ts-static'
import { isNil } from 'embed/utils/object'

interface StoreProps {
  brand: Brand
  hasCmaOffer: boolean
  hasHicOffer: boolean
  hasMmaOffer: boolean
}

const EvenDepositsDisclosure = ({ hasHicOffer, hasMmaOffer, hasCmaOffer }) => (
  <>
    <p>
      The listings that appear on this page are from companies from which Even Financial, Inc. ("Even”, “Even
      Financial”, “we”, “us”, “our”) and its affiliates may receive compensation, which may impact how, where and in
      what order products appear. These listings do not include all companies or all available products. Neither Even
      Financial nor this website endorses or recommends any companies or products. All rates are presented without
      guarantee and are subject to change pursuant to each provider's discretion.
    </p>
    <p>
      APY stands for Annual Percentage Yield. It’s different from interest rate because it takes into account
      compounding interest. An APY is subject to change before and after account opening.
    </p>
    {hasHicOffer && (
      <p>
        A high interest checking account has features of both savings and checking accounts allowing for interest to be
        paid on the money in your account balance. These accounts may have certain additional requirements, exclusions,
        fees and certain minimums in order to earn the interest rate. Please make sure to review the details and Terms
        and Conditions for each provider.
      </p>
    )}
    {hasMmaOffer && (
      <p>
        MMA stands for Money Market Account. It's a savings and checking hybrid, allowing you to earn interest and use
        checks 6 times a month.
      </p>
    )}
    {hasCmaOffer && (
      <p>
        CMA stands for Cash Management Account. It’s an account with an SEC-registered broker dealer that allows your
        funds to be swept nightly to an interest bearing account at a federally insured depository institution.
      </p>
    )}
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even's API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from premium financial
      services providers. All decisions and rates offered, are the responsibility of the participating providers. Any
      trademarks used in connection with any products or services appearing on this website; are the sole property of
      their respective owners. No affiliation or endorsement is intended or implied. Even Financial offices are located
      at 50 West 23rd Street, Suite 700, New York, NY 10010, Telephone number: {formattedPhoneNumber(ContactEven.Phone)}
      . This site is directed at, and made available to, persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const FionaDepositsDisclosure = ({ hasHicOffer, hasMmaOffer, hasCmaOffer }) => (
  <>
    <p>
      The listings that appear on this page are from companies from which Even Financial, Inc. / Fiona ("Even”, “Even
      Financial”, ”Fiona”, “we”, “us”, “our”) and its affiliates may receive compensation, which may impact how, where
      and in what order products appear. These listings do not include all companies or all available products. Neither
      Fiona nor this website endorses or recommends any companies or products. All rates are presented without guarantee
      and are subject to change pursuant to each provider's discretion.
    </p>
    <p>
      APY stands for Annual Percentage Yield. It’s different from an interest rate because it takes into account
      compounding interest. The APY is subject to change before and after account opening.
    </p>
    {hasHicOffer && (
      <p>
        A high interest checking account has features of both savings and checking accounts allowing for interest to be
        paid on the money in your account balance. These accounts may have certain additional requirements, exclusions,
        fees and certain minimums in order to earn the interest rate. Please make sure to review the details and Terms
        and Conditions for each provider.
      </p>
    )}
    {hasMmaOffer && (
      <p>
        MMA stands for Money Market Account. It's a savings and checking hybrid, allowing you to earn interest and write
        checks 6 times a month.
      </p>
    )}
    {hasCmaOffer && (
      <p>
        CMA stands for Cash Management Account. It’s an account with an SEC-registered broker dealer that allows your
        funds to be swept nightly to an interest bearing account at a federally insured depository institution.
      </p>
    )}
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even's API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from premium financial
      services providers. All decisions and rates offered, are the responsibility of the participating partners. Any
      trademarks used in connection with products or services appearing on this website are the sole property of their
      respective owners. No affiliation or endorsement is intended or implied. Even Financial offices are located at 43
      West. 24th Street, - 6th Floor, New York, NY 10010, Telephone number: {formattedPhoneNumber(ContactFiona.Phone)}.
      This site is directed at, and made available to, persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const DepositsDisclosure: React.SFC<StoreProps> = ({ brand, ...props }) => (
  <ThemeConsumer>
    {({ fontFamilySecondary }) => (
      <div
        className={classnames(
          css`
            font-family: ${fontFamilySecondary};
          `,
        )}
      >
        <p>
          <strong>Additional Information</strong>
        </p>
        {brand === Brand.Fiona ? <FionaDepositsDisclosure {...props} /> : <EvenDepositsDisclosure {...props} />}
      </div>
    )}
  </ThemeConsumer>
)

const mapStateToProps = (state: CommonState) => {
  const depositsOffers = depositsSavingsOffersSelector(state)

  return {
    brand: brandSelector(state),
    hasCmaOffer: !isNil(
      depositsOffers.find(
        (depositsOffer: DepositsOffer) => depositsOffer.productSubType === DepositsOfferProductSubType.Cma,
      ),
    ),
    hasHicOffer: !isNil(
      depositsOffers.find(
        (depositsOffer: DepositsOffer) => depositsOffer.productSubType === DepositsOfferProductSubType.Hic,
      ),
    ),
    hasMmaOffer: !isNil(
      depositsOffers.find(
        (depositsOffer: DepositsOffer) => depositsOffer.productSubType === DepositsOfferProductSubType.Mma,
      ),
    ),
  }
}

export default connect(mapStateToProps)(DepositsDisclosure)
